import { useAccountEffect } from '@lair-finance/wagmi'
import { getAuthStore } from '@/domains/auth/model/store.ts'
import { useLogoutMutation } from '@/domains/auth/api/mutations'

export function useLogoutOnWalletDisconnect() {
  const logoutMutation = useLogoutMutation()

  useAccountEffect({
    onDisconnect() {
      if (getAuthStore().isLoggedIn) {
        logoutMutation.mutate()
      }
    },
  })
}
